import * as React from 'react';
import {
    useEffect,
    useState
} from 'react';
import {
    useSelector,
    useDispatch
} from 'react-redux';

import {
    Badge,
    Button,
    Collapse,
    Input,
    Pagination,
    Tabs,
} from 'antd/lib'; 

import { 
    CardErrorMsg,
    CardLockIcon
} from 'one-card-notification';

import notification from 'antd/lib/notification';

import { CardNoData } from 'one-ui-card';

import { useCtx } from "one-ui-provider";

import Select from "antd/lib/select";
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';


import './style.less';
const { Option } = Select;

const { TextArea } = Input;
const { Panel } = Collapse;

/**
 * This function returns all the notes history
 * @param props has all input parameters to load the Card
 * @returns JSX code for notes history
 */
export const NotesHistoryCard = () => {
    const [newNote, setNewNote] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageNotes, setCurrentPageNotes] = useState([]);
    const [activePanel, setActivePanel] = useState(null);

    const insurance = useSelector((state: any) => (state.insurancedetails));

    const dispatch = useDispatch();
    const patients = useSelector((state: any) => (state.selectedsubjectinfo));
    const subject=useSelector((state: any) => (state.subjectstore))
    const notesHistory = useSelector((state: any) => (state.notesHistory));
    const {  settings } = useCtx();
    const { uisettings: { agent_notes: { display: cardDisplay, maxNotesToDisplay,notes_dispositionvalues,notes_disposition, labels = {} as any } } } = settings;

    const {
        newEncounterTab = 'New Telephone Encounter',
        encountersTab = 'Telephone Encounters',
        cardTitle = 'Telephone Encounters',
        createButton = 'Create Telephone Encounter',
        successMessage = 'Telephone Encounter created in Epic',
        errorMessage = 'Failed to create Telephone Encounter',
        epicIndicator = 'Saved to Epic',
        textareaPlaceholder = 'Telephone Encounter Notes',
        dispositionLabel = 'Encounter Disposition',
    } = labels;

    const [notes_disp, setNotes_disp] = useState("");

    let options:any=[];
    options = notes_dispositionvalues?.map((item:any) => {
        return <Option key={item} value={item}>
          {item}
        </Option>
});
useEffect(()=>{
    setNotes_disp("");
},[subject?.selected])
useEffect(() => {
    console.log('value:'); // Log the value for debugging
  }, [notes_disp]);
      const handleChange = (value:string | null) => {
        setNotes_disp(value);
      };
      const handleReset = () => {
        setNotes_disp(""); // Or setValue('') if you prefer string representation
      };
      let data: any = [];

       //Check if the response is available
  if (insurance?.values?.length > 0) {
    insurance?.values.map((insuredata: any) => {
      if(insuredata?.insurancedetailsath?.length > 0) {
        insuredata?.insurancedetailsath.map((moredetails: any) => {
          let infodata =
          {
            info: {
              plan: moredetails.planname ? moredetails.planname : "",
              groupnumber: moredetails.policyid ? moredetails.policyid : "",
            }
          }
          data.push(infodata);
        })
      }
    })
  }
    useEffect(() => {
        if (notesHistory?.notes?.length > 0) {
            let start = (currentPage - 1) * maxNotesToDisplay;
            let end = start + maxNotesToDisplay;
            setCurrentPageNotes(notesHistory.notes.slice(start, end));
        }
    }, [notesHistory?.notes]);

    useEffect(() => {
        if (notesHistory?.status === 200) {
          notification.config({
            placement: "topRight",
            top: 400,
            duration: 3
          });
          notification['success']({
            message: successMessage,
            description: "",
          });
        }
        if (notesHistory?.status === 400) {
          notification.config({
            placement: "topRight",
            top: 400,
            duration: 3
          });
          notification['error']({
            message: errorMessage,
            description: "",
          });
        }
        dispatch({
            type: 'one-state-notes-history/setStatus',
            payload: 0
        });
      }, [notesHistory?.status]);
    
    const handleClickAddNote = () => {
        // if(!notes_disp){
        //     notification.config({
        //         placement: "topRight",
        //         top: 300,
        //         duration: 3
        //     });
        //     notification['error']({
        //         message: 'Alert',
        //         description:
        //             'Select Notes Disposition',
        //     });
        // }
        // else{
        dispatch({
            type: 'notes-history--add',
            payload: {
                patientId: patients?.id,
                note: newNote,
                disposition:notes_disp,
                policynum:data[0]?.info?.groupnumber?data[0]?.info?.groupnumber:""
            }
        });
        setNewNote('');
        setNotes_disp("")
    // }
    };

    const onChange = (page: any) => {
        setCurrentPage(page);
        let start = (page - 1) * maxNotesToDisplay;
        let end = start + maxNotesToDisplay;
        setCurrentPageNotes(notesHistory.notes.slice(start,  end));
        setActivePanel(null);
    };


    if (!cardDisplay) {
        return (
            <div className="notes-history">
                <div className="notes-history--header">
                    <p className="title">{cardTitle}</p>
                </div>
                <div className="notes-history--lock">
                    <CardLockIcon />
                </div>
            </div>
        );
    }

    let addNoteBody = (
        <div className='notes-history--add-note'>
           {notes_disposition? <Row>
                <Col sm={24} md={24} >
                    <div className={'description-info'}>
                        <div className="description-info__item">
                            <b>{dispositionLabel}:</b>
                        </div>
                    </div>
                    <Select size="default" style={{ width: "50%",marginRight:"2rem" }}  onChange={handleChange} value={notes_disp}
                    >
                    {/* Include an empty option for initial state */}
                        {options}
                   
                         </Select>
                         <button onClick={handleReset}>Reset</button>

                </Col>
            </Row>:null}
            <br />
            <TextArea 
                rows={2} 
                aria-label={textareaPlaceholder}
                value={newNote}
                style={{ height: "100px" }}
                onChange={e => setNewNote(e.target.value)}
                title={textareaPlaceholder}
            />
            <div className='opt-crm'>
                <Button 
                    type="primary" 
                    style={{marginTop: '10px'}}
                    onClick={handleClickAddNote}
                    disabled={newNote.trim().length === 0}
                >
                    {createButton}
                </Button>
            </div>
        </div>
    );

    let notesHistoryBody;
    if (notesHistory?.notes?.length > 0) {
        notesHistoryBody = (
            <div className='notes-history--notes-view'>
                <div className='notes-history--notes-view-accordion'>
                    <Collapse 
                        accordion 
                        activeKey={activePanel}
                        onChange={(key) => setActivePanel(key)}
                    >
                        {currentPageNotes?.map((item: any, index: any) => {
                            let panelHeader = (
                                <div className='panel-header'>
                                    <div>{item.agentId} | {item.date} | {item.time}</div>
                                    {item.isEpic && (
                                        <div>{epicIndicator}</div>
                                    )}
                                </div>
                            )
                            return (
                                <Panel 
                                    header={panelHeader}
                                    key={index}
                                >
                                    <p>{item.note}</p>
                                </Panel>
                            )
                        })}
                    </Collapse>
                </div>
                <Pagination
                    current={currentPage} 
                    pageSize={maxNotesToDisplay} 
                    total={notesHistory.notes.length} 
                    onChange={onChange} 
                    size='small'
                />
            </div>
        )
    } else {
        notesHistoryBody = <CardNoData />
    }

    if (notesHistory?.error && notesHistory?.notes?.length === 0) {
        notesHistoryBody = (
            <div 
                className='notes-history--notes-view'
                style={{textAlign: 'center'}}
            >
                <CardErrorMsg />   
            </div>
        )
    }

    return (
        <Tabs defaultActiveKey='1' className='notes-history'>
            <Tabs.TabPane tab={newEncounterTab} key='1'>
                {addNoteBody}
            </Tabs.TabPane>
            <Tabs.TabPane 
                tab={
                    <Badge count={notesHistory?.notes?.length} overflowCount={999}>
                        {encountersTab}
                    </Badge>
                }
                key='2'
            >
                {notesHistoryBody}
            </Tabs.TabPane>
        </Tabs>
    );
};
